module.exports = __webpack_public_path__ + "static/media/nav-icon-feedback-active.8eb01aff.svg";